module.exports = __webpack_public_path__ + "img/1489213662.0a9d1986.jpg";